// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3vSU6","alert":"SettungsInbox_alert__1zJQ6"};